import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
    Layout, Card, List, Typography, Button, InputNumber, Tabs, Tag, Space, Divider,
    Form, Input, Select, Radio, DatePicker, Modal, message, Empty, Spin, Row, Col
} from 'antd';
import {
    ShoppingCartOutlined, DeleteOutlined, MinusOutlined, PlusOutlined,
    EnvironmentOutlined, ArrowLeftOutlined, SaveOutlined, SendOutlined
} from '@ant-design/icons';
import firebase from "../../firebase";
import moment from 'moment';
import 'moment/locale/ja';
import "./MobileCart.css";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Title, Text } = Typography;
const { Option } = Select;

class MobileOtasukeCart extends Component {
    constructor(props) {
        super(props);
        this.itemUnsubscribes = [];
        this.state = {
            cartNo: 0,
            carts: [],
            carriage: 0,
            lastDeliveryAddress: {},
            loading: false,
            fetching: true,
            modalVisible: false,
            modalConfirm: false,
            modalSave: false,
            modalDelete: false,
            modalDelivery: false,
            modalDeliveryDirect: false,
        };
    }

    componentDidMount() {
        const cartNo = parseInt(this.props.id) - 1;
        this.setState({ cartNo: isNaN(cartNo) ? 0 : cartNo }, () => {
            this.getCarts();
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id || this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg) {
            const cartNo = parseInt(this.props.id) - 1;
            this.setState({ cartNo: isNaN(cartNo) ? 0 : cartNo }, () => {
                this.getCarts();
            });
        }
    }

    getCartData = (cartNo = this.state.cartNo) => {
        const { carts } = this.state;
        const cartData = {
            items: [],
            cartName: '',
            orderNo: '',
            toUser: '',
            toUserName: '',
            orderNouki: '最短',
            orderNoukiDay: '',
            orderNoukiDate: '',
            orderBasyo: '登録住所',
            orderPropertyName: '',
            orderZipcode: '',
            orderAddr1: '',
            orderAddr2: '',
            orderJigyosyo: '',
            orderTanto: '',
            orderPhone: '',
            orderBikou: '',
            requested: false,
        };

        if (carts[cartNo]) {
            Object.assign(cartData, carts[cartNo]);
        }
        return cartData;
    };

    getCarts = async () => {
        this.setState({ fetching: true });
        let collection;
        if(this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
            collection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
        } else if(this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
        } else if(this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            collection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
        } else if(this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
            collection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
        }

        if (this.props.org && collection) {
            try {
                let ci = this.props.db.collection('carts_info').doc(this.props.user.id).collection('carts_info').doc(this.props.org.id).get();
                let ocRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id).collection('otasuke_carts').doc(this.props.org.id);
                let oc = ocRef.get();

                let response = await Promise.all([ci, oc]);

                let ciDoc = response[0];
                let ocDoc = response[1];

                let ciData = ciDoc.data();
                if (ciData) {
                    this.setState({ lastDeliveryAddress: ciData.lastDeliveryAddress || {} });
                }

                let ocData = ocDoc.data() || {};
                let hasChanged = false;

                for (let i = 0; i < 5; i++) {
                    let cart = ocData[i];
                    if (cart && cart.items) {
                        let items = cart.items;
                        await Promise.all(items.map(async (item) => {
                            let itemSell = await collection.doc(item.id).get();
                            let itemSellData = itemSell.data();
                            let prevPrice = item.price;
                            let prevDeletedItem = item.deletedItem;
                            item.deletedItem = false;
                            delete item['deletedText'];

                            if (!itemSellData) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '販売終了';
                            } else if (!itemSellData['price'] || (itemSellData && itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                                cart.deletedItem = true;
                                item.deletedItem = true;
                                item.deletedText = '要見積';
                            } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                                let expiration_date = itemSellData['price'][0]['expiration_date'];
                                let expDate = expiration_date && expiration_date.toDate ? expiration_date.toDate() : (expiration_date ? new Date(expiration_date.seconds * 1000) : new Date(0));
                                if ((expDate.getTime() - this.props.dateNow) < 0) {
                                    cart.deletedItem = true;
                                    item.deletedItem = true;
                                    item.deletedText = '要見積';
                                }
                            }

                            if (!item.deletedItem) {
                                let changed = updateItemFromSellData(item, itemSellData);
                                if (changed) hasChanged = true;
                            }
                            if (prevDeletedItem !== item.deletedItem) {
                                hasChanged = true;
                            }
                            if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                                hasChanged = true;
                            }
                        }));
                    }
                }

                if (hasChanged) {
                    await ocRef.set(ocData, { merge: true });
                }

                let total = 0;
                if (ocData[this.state.cartNo] && ocData[this.state.cartNo].items) {
                    ocData[this.state.cartNo].items.forEach(item => {
                        if (item && !item.deletedItem) total += item.count * item.price;
                    });
                }

                let postage = this.calculateCarriage(total);
                this.setState({ carriage: postage, carts: ocData, fetching: false });
                this.setupItemListeners(ocData, collection);
            } catch (error) {
                console.error("Error fetching carts:", error);
                this.setState({ fetching: false });
            }
        } else {
            this.setState({ fetching: false });
        }
    };

    calculateCarriage = (total) => {
        let carriage_free = 0;
        let carriage = 0;
        if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.sellers) {
            this.props.userOrg.sellers.forEach(seller => {
                if (seller.organization === this.props.org.id) {
                    carriage_free = seller.carriage_free || 0;
                    carriage = seller.carriage || 0;
                }
            });
        }
        if (this.props.org && this.props.org.reseller && this.props.userOrg) {
            carriage_free = this.props.userOrg.carriage_free || 0;
            carriage = this.props.userOrg.carriage || 0;
        }
        return total < carriage_free ? carriage : 0;
    };

    detachItemListeners = () => {
        if (this.itemUnsubscribes && this.itemUnsubscribes.length > 0) {
            this.itemUnsubscribes.forEach(unsub => {
                if (typeof unsub === 'function') {
                    unsub();
                }
            });
            this.itemUnsubscribes = [];
        }
    };

    setupItemListeners = (ocData, collection) => {
        this.detachItemListeners();
        if (!collection || !ocData) return;

        let itemIds = new Set();
        for (let i = 0; i < 5; i++) {
            let cart = ocData[i];
            if (cart && cart.items && Array.isArray(cart.items)) {
                cart.items.forEach(item => {
                    if (item && item.id) {
                        itemIds.add(item.id);
                    }
                });
            }
        }

        itemIds.forEach(itemId => {
            let unsub = collection.doc(itemId).onSnapshot((docSnapshot) => {
                let itemSellData = docSnapshot.data();
                this.handleRealtimeItemUpdate(itemId, itemSellData);
            }, (error) => {
                console.error('Realtime mobile otasuke cart item listener error:', itemId, error);
            });
            this.itemUnsubscribes.push(unsub);
        });
    };

    handleRealtimeItemUpdate = (itemId, itemSellData) => {
        if (!this.state.carts) return;

        let currentCarts = this.state.carts;
        let hasChanged = false;
        let updatedCarts = Array.isArray(currentCarts) ? [...currentCarts] : { ...currentCarts };

        for (let i = 0; i < 5; i++) {
            let cart = currentCarts[i];
            if (cart && cart.items && Array.isArray(cart.items)) {
                let cartChanged = false;
                let newItems = cart.items.map(item => {
                    if (item && item.id === itemId) {
                        let clonedItem = { ...item };
                        let prevPrice = clonedItem.price;
                        let prevDeletedItem = clonedItem.deletedItem;
                        clonedItem.deletedItem = false;
                        delete clonedItem['deletedText'];

                        if (!itemSellData) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '販売終了';
                        } else if (!itemSellData['price'] || (itemSellData && itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '要見積';
                        } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                            clonedItem.deletedItem = true;
                            clonedItem.deletedText = '要見積';
                        } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                            let expiration_date = itemSellData['price'][0]['expiration_date'];
                            let expDate = expiration_date && expiration_date.toDate ? expiration_date.toDate() : (expiration_date ? new Date(expiration_date.seconds * 1000) : new Date(0));
                            if ((expDate.getTime() - this.props.dateNow) < 0) {
                                clonedItem.deletedItem = true;
                                clonedItem.deletedText = '要見積';
                            }
                        }

                        if (!clonedItem.deletedItem) {
                            let changed = updateItemFromSellData(clonedItem, itemSellData, false);
                            if (changed) {
                                hasChanged = true;
                                cartChanged = true;
                            }
                        }
                        if (prevDeletedItem !== clonedItem.deletedItem) {
                            hasChanged = true;
                            cartChanged = true;
                        }
                        if (prevPrice !== clonedItem.price && (prevPrice === undefined || Number(prevPrice) !== Number(clonedItem.price))) {
                            hasChanged = true;
                            cartChanged = true;
                        }
                        return clonedItem;
                    }
                    return item;
                });

                if (cartChanged) {
                    let updatedCart = { ...cart, items: newItems };
                    let hasAnyDeleted = newItems.some(it => it.deletedItem);
                    if (hasAnyDeleted) {
                        updatedCart.deletedItem = true;
                    } else {
                        delete updatedCart.deletedItem;
                        delete updatedCart.deletedText;
                    }
                    updatedCarts[i] = updatedCart;
                } else {
                    updatedCarts[i] = cart;
                }
            } else {
                updatedCarts[i] = cart;
            }
        }

        if (hasChanged) {
            let total = 0;
            if (updatedCarts[this.state.cartNo] && updatedCarts[this.state.cartNo].items) {
                updatedCarts[this.state.cartNo].items.forEach(item => {
                    if (item && !item.deletedItem) total += item.count * item.price;
                });
            }
            let postage = this.calculateCarriage(total);
            this.setState({ carts: updatedCarts, carriage: postage });

            let ocRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id).collection('otasuke_carts').doc(this.props.org.id);
            ocRef.set(updatedCarts, { merge: true });
        }
    };

    componentWillUnmount() {
        this.detachItemListeners();
    }

    updateCartToFirebase = async (updatedCart) => {
        let carts = { ...this.state.carts };
        let cartBase = carts[this.state.cartNo] || {};
        
        const date = firebase.firestore.Timestamp.fromDate(new Date());
        cartBase.latestUpdate = date;
        
        let cartRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id).collection('otasuke_carts').doc(this.props.org.id);

        cartBase = { ...cartBase, ...updatedCart };
        carts[this.state.cartNo] = cartBase;

        await cartRef.set({
            [this.state.cartNo]: cartBase,
            update: date,
        }, { merge: true });

        this.setState({ carts });
    };

    handleQuantityChange = (index, value) => {
        let carts = { ...this.state.carts };
        let cart = carts[this.state.cartNo] ? { ...carts[this.state.cartNo] } : { items: [], creatorUser: this.props.user.id };
        if (cart.requested) return;

        cart.items[index].count = value;
        this.updateCartToFirebase(cart);
    };

    deleteItem = async (index) => {
        let carts = { ...this.state.carts };
        let cart = carts[this.state.cartNo] ? { ...carts[this.state.cartNo] } : { items: [], creatorUser: this.props.user.id };
        if (cart.requested) return;

        cart.items.splice(index, 1);
        await this.updateCartToFirebase(cart);
    };

    handleToUserChange = (value) => {
        let carts = { ...this.state.carts };
        let cart = carts[this.state.cartNo] ? { ...carts[this.state.cartNo] } : { items: [], creatorUser: this.props.user.id };
        if (cart.requested) return;

        const selectedUser = this.props.org.users.find(u => u.user === value);
        cart.toUser = value;
        cart.toUserName = selectedUser ? selectedUser.name : '';

        this.updateCartToFirebase(cart);
    };

    handleFormChange = (field, value) => {
        let carts = { ...this.state.carts };
        let cart = carts[this.state.cartNo] ? { ...carts[this.state.cartNo] } : { items: [], creatorUser: this.props.user.id };
        if (cart.requested) return;

        cart[field] = value;
        this.updateCartToFirebase(cart);
    };

    saveCart = async () => {
        let carts = { ...this.state.carts };
        let cartBase = carts[this.state.cartNo] || {};
        cartBase.sendHelpCart = 0;
        await this.updateCartToFirebase(cartBase);
        this.setState({ modalSave: false });
        message.success("お助けカートを保存しました");
    };

    sendOtasukeCart = () => {
        const cartData = this.getCartData();
        if (cartData.orderBasyo === 'アドレス帳から選択する' && Object.keys(cartData.deliveryAddress || {}).length === 0) {
            this.setState({ modalDelivery: true });
            return;
        }

        if (cartData.orderBasyo === '納品先を直接入力する' &&
            !(cartData.orderPropertyName !== '' && cartData.orderZipcode !== '' &&
              cartData.orderAddr1 !== '' && cartData.orderAddr2 !== '' &&
              cartData.orderJigyosyo !== '' && cartData.orderTanto !== '' && cartData.orderPhone !== '')) {
            this.setState({ modalDeliveryDirect: true });
            return;
        }

        this.setState({ modalVisible: true });
    };

    submitOtasukeCart = async (discard) => {
        this.setState({ loading: true, modalVisible: false });
        try {
            let carts = { ...this.state.carts };
            let cartBase = { ...this.getCartData() };

            cartBase.sendHelpCart = 1;
            cartBase.sendHelpCartUser = this.props.user.id;
            cartBase.sendHelpCartUserName = this.props.user.last_name + " " + this.props.user.first_name;
            cartBase.sendHelpCartDate = firebase.firestore.Timestamp.fromDate(new Date());

            let otasukeCartsHistoryRef = this.props.db.collection('otasuke_carts_history').doc();
            let created = firebase.firestore.Timestamp.fromDate(new Date());

            let deliveryAddress = {};
            let noDeliveryAddress = false;

            if (cartBase.orderBasyo === '前回の納品先' && Object.keys(this.state.lastDeliveryAddress).length > 0) {
                deliveryAddress = { ...this.state.lastDeliveryAddress };
                cartBase.deliveryAddress = deliveryAddress;
            } else if (cartBase.orderBasyo === 'アドレス帳から選択する') {
                deliveryAddress = { ...cartBase.deliveryAddress };
            } else if (cartBase.orderBasyo === '納品先を直接入力する') {
                deliveryAddress = {
                    propertyName: cartBase.orderPropertyName, postCode: cartBase.orderZipcode,
                    address1: cartBase.orderAddr1, address2: cartBase.orderAddr2,
                    officeName: cartBase.orderJigyosyo, personInCharge: cartBase.orderTanto,
                    phoneNumber: cartBase.orderPhone
                };
                delete cartBase.deliveryAddress;
            } else if (cartBase.orderBasyo === '納品先を指定しない') {
                delete cartBase.deliveryAddress;
                noDeliveryAddress = true;
            }

            await otasukeCartsHistoryRef.set({
                cart: cartBase,
                cartNo: this.state.cartNo,
                toUser: cartBase.toUser,
                toUserName: cartBase.toUserName,
                toOrganization: this.props.org.id,
                fromUser: this.props.user.id,
                fromUserName: this.props.user.last_name + " " + (this.props.user.first_name || ''),
                fromOrganization: this.props.userOrg?.id,
                created: created,
                dueDate: created.toMillis() + (86400000), // Approximate dueDate
                latestUpdate: created,
                sortDate: created,
                wait: { [this.props.user.id]: true },
                requested: true,
                rejected: false,
                sendHelpCart: 1,
                sendHelpCartUser: this.props.user.id,
                sendHelpCartUserName: this.props.user.last_name + " " + (this.props.user.first_name || ''),
                sendHelpCartDate: cartBase.sendHelpCartDate,
                readBuyer: false
            }, { merge: true });

            let oc = { ...cartBase };
            if (discard) { oc = {}; }

            let cartRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id)
                .collection('otasuke_carts').doc(this.props.org.id);

            await cartRef.set({
                [this.state.cartNo]: oc,
                update: firebase.firestore.Timestamp.fromDate(new Date()),
            }, { merge: true });

            if (!noDeliveryAddress) {
                let cartInfoRef = this.props.db.collection('carts_info').doc(this.props.user.id)
                    .collection('carts_info').doc(this.props.org.id);
                await cartInfoRef.set({
                    lastDeliveryAddress: deliveryAddress,
                    update: firebase.firestore.Timestamp.fromDate(new Date())
                }, { merge: true });
            }

            this.setState({ modalConfirm: true, loading: false });
            this.getCarts();
        } catch (error) {
            console.error("Error submitting:", error);
            message.error('エラーが発生しました');
            this.setState({ loading: false });
        }
    };

    deleteOtasukeCart = async () => {
        this.setState({ loading: true, modalDelete: false });
        let cartRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id)
            .collection('otasuke_carts').doc(this.props.org.id);
        await cartRef.set({
            [this.state.cartNo]: {},
            update: firebase.firestore.Timestamp.fromDate(new Date()),
        }, { merge: true });
        this.getCarts();
        this.setState({ loading: false });
        message.success("お助けカートを削除しました");
    };

    render() {
        const { carts, cartNo, fetching, loading, carriage, lastDeliveryAddress } = this.state;
        const { org } = this.props;

        if (!org) return <div style={{ padding: 20 }}>取引先を選択してください</div>;
        if (fetching) return <div style={{ display: 'flex', justifyContent: 'center', padding: 50 }}><Spin size="large" /></div>;

        const cartData = this.getCartData();
        const items = cartData.items || [];

        let subtotal = 0;
        let taxTotal = 0;
        const taxes = {};

        items.forEach(item => {
            if (!item.deletedItem) {
                const itemTotal = item.count * item.price;
                subtotal += itemTotal;
                const tax = item.tax || 0.1;
                const itemTax = Math.floor(itemTotal * tax);
                taxTotal += itemTax;
                taxes[tax] = (taxes[tax] || 0) + itemTax;
            }
        });

        const grandTotal = subtotal + carriage + taxTotal;

        let archiveFilter = items.filter(v => v.archive === true);
        const disableSend = items.length === 0 || !cartData.toUser || cartData.deletedItem || archiveFilter.length > 0;
        const isDisable = items.length === 0;

        return (
            <div className="mobile-cart-container">
                <div className="mobile-cart-header">
                    <Button icon={<ArrowLeftOutlined />} onClick={() => this.props.history.goBack()} type="text" />
                    <Title level={4} style={{ margin: 0 }}>お助けカート {cartNo + 1}</Title>
                </div>

                <div style={{ padding: '0 16px', marginBottom: 16 }}>
                    <Text strong>カート名称</Text>
                    <Input
                        placeholder="名称未設定"
                        value={cartData.cartName}
                        onChange={(e) => this.handleFormChange('cartName', e.target.value)}
                        disabled={cartData.requested}
                        style={{ marginTop: 8 }}
                    />
                </div>

                <Tabs
                    activeKey={(cartNo + 1).toString()}
                    onChange={(key) => this.props.history.push(`/otasuke/cart/${key}`)}
                    className="mobile-cart-tabs"
                >
                    {[1, 2, 3, 4, 5].map(i => <Tabs.TabPane tab={`カート${i}`} key={i.toString()} />)}
                </Tabs>

                <div style={{ padding: '0 16px 16px', textAlign: 'center' }}>
                    <Button type="primary" onClick={() => this.props.history.push("/items?cn="+ cartNo)}>
                        商品を追加する
                    </Button>
                </div>

                <List
                    dataSource={items}
                    renderItem={(item, index) => (
                        <Card className="mobile-cart-item-card" bodyStyle={{ padding: 12 }}>
                            <div className="mobile-cart-item-content">
                                <div className="mobile-cart-item-header">
                                    <div style={{ flex: 1 }}>
                                        <Link to={`/items/${item.id}`} className="mobile-cart-item-name">{item.name}</Link>
                                        <div className="mobile-cart-item-maker">{item.maker}</div>
                                        {item.archive && <Tag color="error">アーカイブ済みのため送信できません</Tag>}
                                    </div>
                                    <Button
                                        type="text"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => this.deleteItem(index)}
                                        disabled={cartData.requested}
                                    />
                                </div>

                                <div className="mobile-cart-item-price-row">
                                    <div className="mobile-cart-item-unit-price">
                                        {item.deletedItem ? <Text type="danger">{item.deletedText}</Text> : `単価: ¥${item.price.toLocaleString()}`}
                                    </div>
                                    <div className="mobile-cart-item-total-price">
                                        {!item.deletedItem && `¥${(item.count * item.price).toLocaleString()}`}
                                    </div>
                                </div>

                                <div className="mobile-cart-quantity-controls">
                                    <Button
                                        icon={<MinusOutlined />}
                                        onClick={() => this.handleQuantityChange(index, Math.max(0, item.count - 1))}
                                        disabled={item.count <= 0 || cartData.requested}
                                    />
                                    <InputNumber
                                        min={0}
                                        value={item.count}
                                        onChange={(val) => this.handleQuantityChange(index, val)}
                                        disabled={cartData.requested}
                                        style={{ width: 60 }}
                                    />
                                    <Button
                                        icon={<PlusOutlined />}
                                        onClick={() => this.handleQuantityChange(index, item.count + 1)}
                                        disabled={cartData.requested}
                                    />
                                </div>

                                <Input.TextArea
                                    placeholder="備考"
                                    rows={2}
                                    value={item.description}
                                    onChange={(e) => this.handleFormChange('items', items.map((it, i) => i === index ? { ...it, description: e.target.value } : it))}
                                    disabled={cartData.requested}
                                    style={{ marginTop: 12 }}
                                />
                            </div>
                        </Card>
                    )}
                    locale={{ emptyText: <Empty description="お助けカートは空です" /> }}
                />

                <div className="mobile-cart-form-section">
                    <Form layout="vertical">
                        <Form.Item label="発注番号">
                            <Input
                                placeholder="発注番号"
                                value={cartData.orderNo}
                                onChange={(e) => this.handleFormChange('orderNo', e.target.value)}
                                disabled={cartData.requested}
                            />
                        </Form.Item>

                        <Form.Item label={<span>お助けカート送信先 <Tag color="#FF0000" style={{ color: "white", borderRadius: "2px", fontSize: "11px", marginLeft: "4px", padding: "0 4px", lineHeight: "18px" }}>必須</Tag></span>}>
                            <Select
                                placeholder="選択してください"
                                value={cartData.toUser || undefined}
                                onChange={this.handleToUserChange}
                                disabled={cartData.requested}
                            >
                                {org.users && org.users.map(u => <Option key={u.user} value={u.user}>{u.name}</Option>)}
                            </Select>
                        </Form.Item>

                        <Form.Item label="希望納期">
                            <Radio.Group
                                value={cartData.orderNouki || '最短'}
                                onChange={(e) => this.handleFormChange('orderNouki', e.target.value)}
                                disabled={cartData.requested}
                            >
                                <Space direction="vertical">
                                    <Radio value="最短">最短</Radio>
                                    <Radio value="希望">
                                        <Space>
                                            <InputNumber
                                                min={0}
                                                value={cartData.orderNoukiDay}
                                                onChange={(val) => this.handleFormChange('orderNoukiDay', val)}
                                                disabled={cartData.requested || cartData.orderNouki !== '希望'}
                                                size="small"
                                            />
                                            日
                                        </Space>
                                    </Radio>
                                    <Radio value="日付指定">
                                        <DatePicker
                                            value={cartData.orderNoukiDate ? moment(cartData.orderNoukiDate.toDate()) : null}
                                            onChange={(date) => this.handleFormChange('orderNoukiDate', date ? firebase.firestore.Timestamp.fromDate(date.toDate()) : null)}
                                            disabled={cartData.requested || cartData.orderNouki !== '日付指定'}
                                            style={{ width: '100%' }}
                                        />
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item label="納品場所">
                            <Radio.Group
                                value={cartData.orderBasyo}
                                onChange={(e) => this.handleFormChange('orderBasyo', e.target.value)}
                                disabled={cartData.requested}
                                style={{ width: '100%' }}
                            >
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Card size="small" style={{ width: '100%' }}>
                                        <Radio value="前回の納品先" disabled={!Object.keys(lastDeliveryAddress).length}>
                                            前回の納品先
                                        </Radio>
                                        {lastDeliveryAddress.address1 && (
                                            <div style={{ fontSize: 12, color: '#666', marginTop: 4, paddingLeft: 24 }}>
                                                {lastDeliveryAddress.propertyName}<br/>
                                                {lastDeliveryAddress.address1} {lastDeliveryAddress.address2}
                                            </div>
                                        )}
                                    </Card>

                                    <Card size="small" style={{ width: '100%' }}>
                                        <Radio value="アドレス帳から選択する">
                                            アドレス帳から選択する
                                        </Radio>
                                        <Button
                                            size="small"
                                            icon={<EnvironmentOutlined />}
                                            onClick={() => this.props.history.push(`/deliveryAddress?cn=${cartNo}&ct=otasuke`)}
                                            disabled={cartData.requested}
                                            style={{ marginLeft: 24, marginTop: 8 }}
                                        >
                                            アドレス帳を開く
                                        </Button>
                                        {cartData.deliveryAddress && cartData.deliveryAddress.address1 && (
                                            <div style={{ fontSize: 12, color: '#666', marginTop: 4, paddingLeft: 24 }}>
                                                {cartData.deliveryAddress.propertyName}<br/>
                                                {cartData.deliveryAddress.address1} {cartData.deliveryAddress.address2}
                                            </div>
                                        )}
                                    </Card>

                                    <Card size="small" style={{ width: '100%' }}>
                                        <Radio value="納品先を直接入力する">
                                            納品先を直接入力する
                                        </Radio>
                                        {cartData.orderBasyo === '納品先を直接入力する' && (
                                            <div style={{ marginTop: 12, paddingLeft: 24 }}>
                                                <Input placeholder="物件名" value={cartData.orderPropertyName} onChange={(e) => this.handleFormChange('orderPropertyName', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="郵便番号" value={cartData.orderZipcode} onChange={(e) => this.handleFormChange('orderZipcode', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="住所1" value={cartData.orderAddr1} onChange={(e) => this.handleFormChange('orderAddr1', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="住所2" value={cartData.orderAddr2} onChange={(e) => this.handleFormChange('orderAddr2', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="事業所名" value={cartData.orderJigyosyo} onChange={(e) => this.handleFormChange('orderJigyosyo', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="担当者名" value={cartData.orderTanto} onChange={(e) => this.handleFormChange('orderTanto', e.target.value)} disabled={cartData.requested} style={{ marginBottom: 8 }} />
                                                <Input placeholder="電話番号" value={cartData.orderPhone} onChange={(e) => this.handleFormChange('orderPhone', e.target.value)} disabled={cartData.requested} />
                                            </div>
                                        )}
                                    </Card>

                                    <Card size="small" style={{ width: '100%' }}>
                                        <Radio value="納品先を指定しない">
                                            納品先を指定しない
                                        </Radio>
                                    </Card>
                                </Space>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item label="備考">
                            <Input.TextArea
                                rows={3}
                                value={cartData.orderBikou}
                                onChange={(e) => this.handleFormChange('orderBikou', e.target.value)}
                                disabled={cartData.requested}
                            />
                        </Form.Item>
                    </Form>
                </div>

                <div className="mobile-cart-footer">
                    <div className="mobile-cart-summary">
                        <div className="mobile-cart-summary-row">
                            <Text>運賃</Text>
                            <Text>¥{carriage.toLocaleString()}</Text>
                        </div>
                        <div className="mobile-cart-summary-row">
                            <Text>消費税額</Text>
                            <Text>¥{taxTotal.toLocaleString()}</Text>
                        </div>
                        <div className="mobile-cart-summary-row">
                            <Text className="mobile-cart-total-label">合計 (税込)</Text>
                            <Text className="mobile-cart-total-value">¥{grandTotal.toLocaleString()}</Text>
                        </div>
                    </div>

                    <Space direction="vertical" style={{ width: '100%', marginTop: 12 }}>
                        <Button
                            type="primary"
                            size="large"
                            block
                            loading={loading}
                            disabled={disableSend}
                            onClick={this.sendOtasukeCart}
                            style={{ backgroundColor: '#00C851', borderColor: '#00C851' }}
                            icon={<SendOutlined />}
                        >
                            このお助けカートを送信する
                        </Button>
                        <Row gutter={8}>
                            <Col span={12}>
                                <Button block danger onClick={() => this.setState({ modalDelete: true })} disabled={isDisable}>削除する</Button>
                            </Col>
                            <Col span={12}>
                                <Button block onClick={() => this.setState({ modalSave: true })} disabled={isDisable} icon={<SaveOutlined />}>保存する</Button>
                            </Col>
                        </Row>
                    </Space>
                </div>

                {/* Modals */}
                <Modal
                    title="お助けカート送信"
                    open={this.state.modalVisible}
                    onCancel={() => this.setState({ modalVisible: false })}
                    footer={[
                        <Button key="cancel" onClick={() => this.setState({ modalVisible: false })}>キャンセル</Button>,
                        <Button key="discard" danger onClick={() => this.submitOtasukeCart(true)}>カート内容を破棄して送信</Button>,
                        <Button key="submit" type="primary" onClick={() => this.submitOtasukeCart(false)}>カート内容を保存して送信</Button>,
                    ]}
                >
                    <p>お助けカート「{cartData.cartName}」を相手先に送信します。</p>
                </Modal>

                <Modal
                    title="お助けカート送信完了"
                    open={this.state.modalConfirm}
                    onOk={() => this.setState({ modalConfirm: false })}
                    onCancel={() => this.setState({ modalConfirm: false })}
                    okText="確認"
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <p>送信しました。</p>
                </Modal>

                <Modal
                    title="お助けカート保存"
                    open={this.state.modalSave}
                    onOk={this.saveCart}
                    onCancel={() => this.setState({ modalSave: false })}
                    okText="保存する"
                    cancelText="キャンセル"
                >
                    <p>お助けカート「{cartData.cartName}」を保存します。</p>
                </Modal>

                <Modal
                    title="お助けカート削除"
                    open={this.state.modalDelete}
                    onOk={this.deleteOtasukeCart}
                    onCancel={() => this.setState({ modalDelete: false })}
                    okText="削除する"
                    cancelText="キャンセル"
                    okButtonProps={{ danger: true }}
                >
                    <p>お助けカート「{cartData.cartName}」を削除します。よろしいですか？</p>
                </Modal>

                <Modal
                    title="納品先が指定されていません"
                    open={this.state.modalDelivery}
                    onOk={() => this.setState({ modalDelivery: false })}
                    onCancel={() => this.setState({ modalDelivery: false })}
                    okText="確認"
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <p>アドレス帳から納品先が指定されていません。</p>
                </Modal>

                <Modal
                    title="未入力項目があります"
                    open={this.state.modalDeliveryDirect}
                    onOk={() => this.setState({ modalDeliveryDirect: false })}
                    onCancel={() => this.setState({ modalDeliveryDirect: false })}
                    okText="確認"
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <p>直接入力の場合は全項目を入力してから送信ボタンをクリックしてください。</p>
                </Modal>
            </div>
        );
    }
}

export default withRouter(MobileOtasukeCart);
